import { AboutExplanation } from './aboutExplanation/AboutExplanation';

import styles from './styles.module.scss';

export const AboutExplanationPage = () => {
  return (
    <div className={styles.keyLostPage}>
      <AboutExplanation />
    </div>
  );
};
